<template>
  <div>

    <div class="xes-1v1-select-city">
      <div class="xes-1v1-select-city-tips">
        <span>已选择:</span>
        <span class="xes-1v1-select-city-alselect">{{ select_city }}</span>
      </div>
      <div class="xes-1v1-select-city-list">
        <yan-index-bar :index-list="indexList" :sticky="true" :sticky-offset-top="60">

          <div v-for="(item, index) in result_city_list" :key="item.letter">
            <van-index-anchor :index="item.letter" />

            <div class="xes-1v1-select-city-content" v-for="(city, sub_index) in item.list" :key="sub_index"
              @click="selectCurrCity(index, sub_index)">
              {{ city.name }}
            </div>

          </div>
        </yan-index-bar>

      </div>
      <!-- <ul v-if="list.length" class="xes-1v1-select-city-list">
        <li v-for="(item, index) in list" :key="index" style="margin-top: 16px">
          <div class="xes-1v1-select-city-content" @click="selectCurrCity(index)">
            {{ item.name }}
            <img class="xes-1v1-select-city-select-img" v-show="select_index === index"
              src="../../assets/img/myPackage/option_select@2x.png" alt="" />
          </div>
        </li>
      </ul> -->
    </div>

    <div class="xes-1v1-select-city-next">
      <button class="xes-1v1-select-city-next-btn" :class="{ 'xes-1v1-select-city-next-btn-active': this.select_city }"
        @click="goNext">下一步
      </button>
    </div>

  </div>
</template>

<script>

import { Toast } from "vant";
import { IndexBar, IndexAnchor } from 'vant'
// import pinyin from 'js-pinyin'
export default {
  components: {
    'yan-index-bar': IndexBar,
    'van-index-anchor': IndexAnchor
  },
  data() {
    return {
      list: require('../../assets/json/city_list.json'),
      select_index: -1,
      select_city: "",
      grade_id: this.$route.query.grade_id,
      uid: this.$route.query.uid,
      result_city_list: [],
      indexList: [],
      select_sub_index: -1,
    }
  },

  created() {
    const pinyin = require('js-pinyin');
    this.list.forEach((item) => {
      item.pinyin = pinyin.getFullChars(item.name)
    })

    let provice = {}
    this.list.forEach((item) => {
      const initials = item.pinyin[0].toUpperCase()
      if (provice[initials]) {
        provice[initials].push(item)
      } else {
        provice[initials] = [item]
      }
    })

    this.result_city_list = []
    for (let key in provice) {
      const obj = { letter: key, list: provice[key] }
      this.result_city_list.push(obj)
    }


    this.result_city_list.sort((a, b) => { return a.letter.localeCompare(b.letter) });
    // 为索引字符数组赋值
    this.indexList = [];
    this.result_city_list.forEach(item => this.indexList.push(item.letter));
  },
  methods: {
    selectCurrCity(index, sub_index) {
      this.select_index = index;
      this.select_sub_index = sub_index;
      this.select_city = this.result_city_list[index].list[sub_index].name
    },

    goNext() {
      if (!this.select_city) {
        return
      }
      let selectCity = this.result_city_list[this.select_index].list[this.select_sub_index].localCity
      // localStorage.setItem("talCityCode", selectCity)
      if (this.grade_id && this.grade_id !== "undefined" && parseInt(this.grade_id) !== 0) {

        let params = {
          action: 2, // 1 拒绝
          channel: "app",
          grade_id: parseInt(this.grade_id), // 10 11 12
          city_code: selectCity.toString(),
          uid: parseInt(this.uid),
        }
        this.$api.clueTeacherForm.authSubmit(params).then((res) => {
          if (res.error_code === 0 && res.result) {
            this.$router.push({
              path: "/auth/authResult",
              query: {
                succFlag: res.result.status,
                tips: res.result.message,
              }
            });
          } else {
            Toast(res.message)
          }

        })
      } else {
        this.$router.push({
          path: "/auth/SelectGrade",
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.xes-1v1-select-city {
  

  &-tips {
    position: fixed;
    top: 0;
    left:0;
    width: 100%;
    padding:16px 0 16px 16px;
    font-family: PingFang SC, serif;
    border-bottom: 1px solid #EDEDED;
    background: white;
    color: #212832;
    font-size:16px;
    font-weight: 500;
    z-index: 999;
    
  }

  &-alselect {
    font-family: PingFang SC, serif;
    font-size: 16px;
    color: #E02727;
    font-weight: 500;
  }

  &-content {
    font-family: PingFang SC, serif;
    font-weight: 500;
    height: 40px;
    font-size: 14px;
    color: #212832;
    padding: 0 24px 0 16px; 

    // .van-index-anchor {
    //   padding: 0, 0 !important;
    //   color: red !important;
    // }
  }

  .xes-1v1-select-city-list {
    margin: 60px 0 0 0;
    padding-bottom: 93px;
  }

}

.xes-1v1-select-city-next {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  position: fixed;
  height: 93px;
  border-top: 1px solid #f0f0f0;
  bottom: 0;
  left: 0px;
  right: 0px;
  padding: 0px 20px 21px 20px;
  z-index: 999;

  .xes-1v1-select-city-next-btn {
    font-size: 16px;
    border-radius: 24px;
    color: white;
    height: 44px;
    width: 100%;
    background-color: #E7E8EA;
  }

  .xes-1v1-select-city-next-btn-active {
    background-color: #E02727;
    color: white;
  }
}
</style>